import { useCallback, useMemo, useState } from 'react';
import { UbsValidateDialog } from '@frameio/brand-validation';
import { useSelectionForOperations } from '../../selection';

export const useManageUbsValidateDialog = () => {
  const [isShowing, setIsShowing] = useState(false);
  const { selectedIds: selectedAssetIds, assetTypeMap } =
    useSelectionForOperations(false);

  const selectedImageAssetIds = useMemo(
    () => selectedAssetIds.filter((id) => assetTypeMap[id] === 'ImageAsset'),
    [assetTypeMap, selectedAssetIds]
  );

  const onClose = useCallback(({ callback }: { callback?: () => void }) => {
    callback?.();
    setIsShowing(false);
  }, []);

  const createUbsValidateDialog = useCallback(
    ({ onClose: onDialogClose }: { onClose?: () => void }) => {
      if (!isShowing) return null;
      if (selectedImageAssetIds.length === 0) return null;
      return (
        <UbsValidateDialog
          assetIds={selectedImageAssetIds}
          isShowing={isShowing}
          onClose={() => onClose({ callback: onDialogClose })}
          totalSelectedCount={selectedAssetIds.length}
        />
      );
    },
    [isShowing, onClose, selectedAssetIds.length, selectedImageAssetIds]
  );

  const openUbsValidateDialog = () => {
    setIsShowing(true);
  };

  return {
    createUbsValidateDialog,
    isShowing,
    openUbsValidateDialog,
  };
};
